//#region Imports
import { Component, Input, OnInit } from '@angular/core';
import { InitialPipe } from '../../pipes/initial.pipe';
import { ModalAction, ModalOptionsComponent } from '../../modals/modal-options/modal-options.component';
import { NgClass } from '@angular/common';
//#endregion

@Component({
  selector: 'l-initial-circle',
  standalone: true,
  template: `
    <div
      class="w-10 h-10 rounded-full text-white flex items-center justify-center font-semibold text-sm transition select-none"
      [class]="randomBgClass"
      [ngClass]="{'cursor-pointer hover:brightness-90': hasModal}"
      (click)="toggleModal()"
      tabindex="0"
      role="button"
      aria-label="Abrir opções do usuário"
    >
      {{ name | initial }}
    </div>

    @if (isModalOpen && hasModal) {
      <l-modal-options
        [actions]="modalActions"
        (close)="closeModal()"
        class="absolute right-0 mt-2 z-[120]"
      ></l-modal-options>
    }
  `,
  imports: [InitialPipe, ModalOptionsComponent, NgClass],
})
export class InitialCircleComponent implements OnInit {

  //#region Public Properties

  @Input()
  public name?: string;

  @Input()
  public hasModal: boolean = false;

  @Input()
  public modalActions: ModalAction[] = [];

  public isModalOpen: boolean = false;

  public randomBgClass: string = 'bg-lPurple700';

  //#endregion

  //#region Private Properties
  
  private bgClasses: string[] = [
    'bg-lPurple700',
    'bg-lBlue600',
    'bg-lBrow300',
    'bg-lGray800',
    'bg-lWarning'
  ];

  //#endregion

  //#region Public Methods

  public ngOnInit(): void {
    const randomIndex = Math.floor(Math.random() * this.bgClasses.length);
    this.randomBgClass = this.bgClasses[randomIndex];
  }

  public toggleModal(): void {
    if (!this.hasModal) return;

    this.isModalOpen = !this.isModalOpen;
  }

  public closeModal(): void {
    this.isModalOpen = false;
  }

  //#endregion

}
